import { useState } from 'react';
import { faqs } from '@/mocks/faq';

export default function FAQSection() {
  const [openId, setOpenId] = useState<number | null>(null);

  const toggle = (id: number) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section className="py-20 md:py-28 px-6 bg-background-50">
      <div className="mx-auto" style={{ maxWidth: 800 }}>
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            关于91网，你可能想知道
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            快速解答您的疑问，帮助您更好地使用91网
          </p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="rounded-xl border border-background-200/70 bg-background-100 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
                onClick={() => toggle(faq.id)}
              >
                <span className="font-medium text-sm text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`flex-shrink-0 text-foreground-400 transition-transform duration-300 text-lg ${
                    openId === faq.id ? 'ri-subtract-line' : 'ri-add-line'
                  }`}
                />
              </button>
              {openId === faq.id && (
                <div className="px-6 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed border-t border-background-200/70 pt-4">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}